import { Trans } from '@lingui/react'
import { type VFC } from 'react'

import Item from 'views/components/organisms/CmsMobileMenu/Item'
import { type AuthHeaderProps } from 'views/components/organisms/CmsMobileMenu/types'
import withMountPoints from 'views/enhancers/withMountPoints'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

const AuthHeader: VFC<AuthHeaderProps> = ({
  mountPoints,
  subscriptionService,
  userLoggedIn,
}) => (
  <ul className="a-list-reset">
    {userLoggedIn ? (
      <>
        <li>
          <Item href={mountPoints.getUserAccount()} name="off-canvas-login">
            <Trans id="offcanvas.link.myApotheke" />
          </Item>
        </li>
        {subscriptionService && (
          <li data-clientside-hook="headerAboLink" aria-hidden>
            <Item href={mountPoints.getAccountSubscriptions()}>
              <Trans id="menubar.AccountFlyout.link.myAbos" />
            </Item>
          </li>
        )}
      </>
    ) : (
      <li>
        <Item href={mountPoints.getLogin()} name="off-canvas-login">
          <Trans id="offcanvas.link.loginOrRegister" />
        </Item>
      </li>
    )}
  </ul>
)

export default withMountPoints(withShopAndRuntimeConfig(AuthHeader))
